import { useSyncExternalStore } from "react"

const QUERY = "(prefers-reduced-motion: reduce)"

const getSnapshot = () => {
  // Guard against SSR and JSDOM
  if (typeof window === "undefined" || !window.matchMedia) {
    return false
  }
  return window.matchMedia(QUERY).matches
}

const subscribe = (callback: () => void) => {
  // Guard against SSR and JSDOM
  if (typeof window === "undefined" || !window.matchMedia) {
    return () => {}
  }

  const mediaQuery = window.matchMedia(QUERY)
  mediaQuery.addEventListener("change", callback)

  return () => mediaQuery.removeEventListener("change", callback)
}

const getServerSnapshot = () => false

export const useReducedMotion = () => {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
